import React, { useCallback, useEffect, useState } from 'react';
import Snackbar from 'housecall-ui/dist/DesignSystem/Feedback/Snackbar/Snackbar';
import { useFlags } from 'launchdarkly-react-client-sdk';

import BrowserPush from '@/BrowserPush';
import defaultChatGroups from 'components/Chat/defaultChatGroups';
import { CUSTOMER_CHAT_WEB, EMPLOYEE_CHAT_WEB } from 'components/LaunchDarkly/FeatureKeys';

export type Payload = {
  data?: {
    message: string;
    sendbird?: string;
  };
};
export type SendbirdPayloadData = {
  channel: {
    name: string;
    channel_url: string;
    custom_type: string;
  };
  message_id: string;
};

export default function NotificationsSnackbar(): JSX.Element | null {
  const [state, setState] = useState<{ open: boolean; message?: string; url?: string }>({ open: false });
  const ldFlags = useFlags();
  const chatEnabled = ldFlags[EMPLOYEE_CHAT_WEB] || ldFlags[CUSTOMER_CHAT_WEB];

  const handleNotifications = useCallback(
    (payload: Payload) => {
      const payloadData = payload?.data;
      if (payloadData?.sendbird && chatEnabled) {
        const { data: { message = '', sendbird = '{}' } = {} } = payload;
        const sendbirdData: SendbirdPayloadData = JSON.parse(sendbird);
        const {
          channel: { name: channelName, channel_url: channelId, custom_type: customType },
          message_id: messageId,
        } = sendbirdData;

        const categoryId =
          defaultChatGroups.find((group) => group.custom_types?.includes(customType))?.id || customType;
        const categoryUrl = categoryId ? `categories/${categoryId}` : '';
        const chatRoomUrl = categoryUrl && channelId ? `/chat_rooms/${channelId}` : '';
        const messageUrl = chatRoomUrl && messageId ? `/messages/${messageId}` : '';
        const url = `/pro/inbox/${categoryUrl}${chatRoomUrl}${messageUrl}`;
        setState({ open: true, message: `Message from ${channelName}: ${message}`, url });
      }
    },
    [chatEnabled]
  );

  useEffect(() => {
    if (BrowserPush.isInitialized) {
      BrowserPush.registerListener(handleNotifications);
    }
  }, [handleNotifications]);

  return state.open ? (
    <Snackbar
      open={state.open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      message={state.message}
      actionMessage="Go to chat"
      onClick={() => {
        window.location.href = state.url || '/pro/inbox/';
      }}
      onClose={() => setState({ open: false })}
      autoHideDuration={4000}
    />
  ) : null;
}
